window.addEventListener('load', function() {
  // Page has loaded, remove loading class
  document.body.classList.remove('loading');
});
